module.exports = __webpack_public_path__ + "img/bottle_audit.b1baec56.png";